import billing from './billing';
import { NavItemType } from 'types';
import { NavItemWithPermissions, NavItemWithPermissionsToNavItem } from './menu-permission/NavItemTypeExtended';
import { usePermissions } from 'hooks/Permission/usePermission';
import useAuth from 'hooks/useAuth';

const menuItems: NavItemWithPermissions[] = [billing];

export function useMenuItems(): { items: NavItemType[] } {
  const { hasPermission } = usePermissions();
  const { user } = useAuth();
  const userRoles = (user?.roles ?? []).map((role) => role.toLowerCase());
  const hasRole = (roles: string[]) => roles.some((role) => userRoles.includes(role.toLowerCase()));

  const items = menuItems
    .map((item) => NavItemWithPermissionsToNavItem(item, hasPermission, hasRole))
    .filter((item): item is NavItemType => item !== null);

  return { items };
}
